// PL
export const propCreateHc = {
  firstCreate: {
    // Typy zakwaterowania
    typeApartmentLabel: `Apartament`,
    typeApartmentDesc: `Umeblowane, samodzielne lokum wynajmowane w całości.`,
    typeVillaLabel: `Willa lub dom`,
    typeVillaDesc: `Domy, wille i domki wynajmowane w całości.`,
    typeHotelLabel: `Hotel, hostel lub B&B`,
    typeHotelDesc: `Obiekty, które zarządzają wieloma pokojami.`,
    typeCampingLabel: `Kemping`,
    typeCampingDesc: `Kempingi i pola z wieloma miejscami lub jednostkami.`,

    // Nazwy obiektu / jednostki
    venueHotel: `hotel`,
    venueCamping: `kemping`,
    roomHotel: `pokój`,
    roomCamping: `parcela`,
    roomHotelPlural: `pokoje`,
    roomCampingPlural: `parcele`,
    yourVenue: `Twój {venue}`,

    // Wspólne przyciski
    back: `Wstecz`,
    continue: `Dalej`,

    // Krok: typ
    typeTitle: `Dodajmy Twoje zakwaterowanie!`,
    typeSubtitle: `Na początek wybierz typ zakwaterowania, które chcesz opublikować.`,

    // Krok: liczba
    quantityTitle: `Ile zakwaterowań chcesz dodać?`,
    quantitySubtitle: `Możesz zacząć od jednego lub utworzyć kilka naraz.`,
    oneTitle: `1 zakwaterowanie`,
    oneDesc: `Na razie chcę opublikować tylko jedno.`,
    manyTitle: `Więcej niż 1 zakwaterowanie`,
    manyDesc: `Mam kilka do dodania.`,

    // Krok: lokalizacja (ten sam budynek czy nie)
    locationTitle: `Czy znajdują się w tym samym budynku lub pod tym samym adresem?`,
    locationSubtitle: `To pomoże nam jak najlepiej uporządkować Twoje zakwaterowania.`,
    sameBuildingYesTitle: `Tak, w tym samym budynku lub pod tym samym adresem`,
    sameBuildingYesDesc: `Zostaną zgrupowane w jednej ofercie z wieloma jednostkami.`,
    sameBuildingNoTitle: `Nie, pod różnymi adresami`,
    sameBuildingNoDesc: `Każde będzie osobną ofertą (skonfigurujesz je później).`,

    // Krok: nazwy (dynamiczne tytuły i podtytuły)
    namesTitleAttach: `Dodaj jednostkę do swojej oferty`,
    namesTitleHotel: `Jak nazywa się Twój {venue}?`,
    namesTitleGrouped: `Nazwij każdą jednostkę`,
    namesTitleList: `Nazwij każde zakwaterowanie`,
    namesTitleDefault: `Jak nazywa się Twoje zakwaterowanie?`,
    namesSubAttach: `Zostanie dodana jako nowa jednostka w: „{name}”.`,
    yourListing: `Twoja oferta`,
    namesSubHotel: `To nazwa, którą zobaczą Twoi goście. W następnym kroku dodasz typy ({room}).`,
    namesSubGrouped: `Każda jednostka będzie miała własny kalendarz w ramach tej samej oferty.`,
    namesSubList: `Każde będzie osobną ofertą z własnymi ustawieniami.`,
    namesSubDefault: `To nazwa, którą zobaczą Twoi goście. Możesz ją zmienić w dowolnym momencie.`,
    addUnitLabel: `Dodaj kolejną jednostkę`,
    addListingLabel: `Dodaj kolejne zakwaterowanie`,

    // Karta oferty głównej (zgrupowane)
    mainListingEyebrow: `Oferta główna`,
    mainListingSub: `Grupuje wszystkie jednostki w tym budynku w jednej ofercie.`,
    mainListingNameLabel: `Nazwa głównego zakwaterowania`,
    mainListingNamePlaceholder: `Np. Residencial Bilbao`,
    mainListingNameHint: `Budynek, wieża lub lokalizacja, która grupuje jednostki.`,
    currency: `Waluta`,
    currencyHintUnit: `Cena za noc dla każdej jednostki.`,

    // Karty jednostek
    unitNameLabel: `Nazwa jednostki`,
    listingNameLabel: `Nazwa zakwaterowania`,
    phRoomCamping: `Np. Kemping Pinar del Mar`,
    phRoomHotel: `Np. Hotel Costa Azul`,
    phAttach: `Np. Luksusowe studio przy Playa Roca, pierwsza linia brzegowa`,
    phGrouped: `Np. Apartament {n}A`,
    phList: `Zakwaterowanie {n}`,
    phDefault: `Np. Apartament w centrum`,
    remove: `Usuń`,
    internalNameOptional: `Nazwa wewnętrzna (opcjonalnie)`,
    pricePerNight: `Cena / noc`,
    currencyHintHotel: `Wszystkie {rooms} używają tej waluty.`,

    // Nazwa wewnętrzna (przypadek jednej nazwy)
    internalNameLabel: `Nazwa wewnętrzna`,
    optional: `(opcjonalnie)`,
    internalNamePlaceholderSingle: `Np. Apartament po remoncie 2024 / klucze u konsjerża`,
    internalNameHint: `Widzisz ją tylko Ty, aby rozpoznać obiekt wewnętrznie. Nie jest pokazywana gościom.`,

    // Krok: typy pokoi (hotel/kemping)
    roomsTitle: `Jakie {rooms} ma {venue}?`,
    roomsSubtitle: `Dodaj każdy typ ({room}) wraz z liczbą i ceną za noc. Możesz to zmienić w dowolnym momencie.`,
    roomTypeLabel: `Typ ({room})`,
    phRoomTypeCamping: `Np. Parcela z prądem`,
    phRoomTypeHotel: `Np. Pokój dwuosobowy deluxe`,
    quantity: `Liczba`,
    addRoomType: `Dodaj typ ({room})`,

    // Krok: adres
    addressTitle: `Gdzie znajduje się Twoje zakwaterowanie?`,
    addressSubtitle: `Zacznij pisać i wybierz adres. Używamy go do mapy i check-inu.`,
    country: `Kraj`,
    countryHint: `Będziemy szukać adresów tylko w tym kraju.`,
    address: `Adres`,
    addressPlaceholder: `Ulica, numer, miasto…`,
    addressPlaceholderNoCountry: `Najpierw wybierz kraj`,
    city: `Miasto`,
    zipCode: `Kod pocztowy`,

    // Krok: cena
    priceTitle: `Twoja standardowa cena za noc`,
    priceSubtitle: `To Twoja cena bazowa. Możesz ją potem dostosować do sezonu lub kanału.`,
    priceLabel: `Cena za noc`,
    perNight: `/ noc`,
    priceHint: `Możesz ją zmienić w dowolnym momencie w panelu.`,

    // Przycisk główny i powód utworzenia
    createUnit: `Dodaj jednostkę`,
    createVenue: `Utwórz mój {venue}`,
    createListingsPlural: `Utwórz moje zakwaterowanie | Utwórz moje {count} zakwaterowania | Utwórz moje {count} zakwaterowań`,
    reasonUnit: `jednostka`,
    reasonListing: `oferta`,

    // Powiadomienia / walidacja
    toastCompleteToContinue: `Uzupełnij dane, aby kontynuować.`,
    toastCompleteNames: `Uzupełnij nazwę każdego zakwaterowania.`,
    toastCompleteLocation: `Uzupełnij lokalizację.`,
    toastCompleteRooms: `Uzupełnij każdy pokój: nazwę, liczbę i cenę za noc.`,
    toastRoomRatePerUnit: `Wpisz cenę za noc dla każdej jednostki.`,
    toastCompleteRate: `Uzupełnij cenę za noc.`,
    toastCreatedPlural: `Zakwaterowanie utworzone! | Zakwaterowania utworzone! | Zakwaterowania utworzone!`,
    toastCreateError: `Nie udało się utworzyć zakwaterowania. Spróbuj ponownie.`,
  },

  welcome: {
    // Tytuły nagłówków
    arrivalTitleCaps: `Instrukcje przyjazdu`,
    arrivalTitle: `Instrukcje przyjazdu`,
    arrivalSubtitle: `Wiadomość, którą gość otrzymuje w dniu przyjazdu.`,
    welcomeTitle: `Wiadomość powitalna`,
    welcomeSubtitle: `Wiadomość, którą gość otrzymuje po ukończeniu check-inu.`,
    loadingMessages: `Wczytywanie wiadomości...`,

    // Powitanie na poziomie pokoju
    roomWelcomeTitle: `Wiadomość powitalna dla tego pokoju`,
    roomWelcomeSub: `Jeśli zostawisz to pole puste, wysyłana jest ogólna wiadomość powitalna hotelu. Przełącznik, załączniki i OTA konfiguruje się na poziomie hotelu.`,

    // Przełącznik powitania
    welcomeEnableTitle: `Wysyłaj wiadomość powitalną`,
    welcomeEnableSub: `Gość otrzymuje ją po ukończeniu check-inu. Po wyłączeniu nie będzie wysyłana.`,

    // Klonowanie
    clone: `Klonuj`,
    clonePullTitle: `Pobierz ustawienia z innego zakwaterowania`,
    clonePullSub: `Zaimportuj powitanie z innego do tego`,
    clonePushTitle: `Skopiuj tę konfigurację do innego zakwaterowania`,
    clonePushSub: `Zastosuj to powitanie w innych`,
    cloneModalPullTitle: `Pobierz ustawienia powitania`,
    cloneModalPushTitle: `Skopiuj wiadomość powitalną`,
    cloneModalPullSubtitle: `Wybierz zakwaterowanie, z którego chcesz pobrać ustawienia. Zostaną zastosowane w tej ofercie.`,
    cloneModalPushSubtitle: `Skopiuj tę konfigurację (teksty, tryb, OTA i załączniki) do wybranych zakwaterowań.`,
    itemNounWelcome: `wiadomość powitalną`,
    arrivalTitleNoun: `instrukcje przyjazdu`,
    itemNounArrival: `instrukcje przyjazdu`,

    // Tryb konfiguracji
    modeConfigLabel: `Tryb konfiguracji`,
    modeSingleTitle: `Jedna wiadomość`,
    modeSingleDesc: `Wszystkie jednostki mają tę samą wiadomość`,
    modeActive: `Aktywny`,
    modePropertyTitle: `Osobno dla każdego obiektu`,
    modePropertyDesc: `Każda jednostka ma własną wiadomość`,
    modePropertyNotice: `Tryb indywidualny jest aktywny. Edytuj wiadomość w każdym obiekcie osobno.`,

    // Przełącznik instrukcji przyjazdu
    arrivalEnableTitle: `Wysyłaj instrukcje przyjazdu`,
    arrivalAutoSend: `Są wysyłane automatycznie w dniu przyjazdu{atTime}.`,
    arrivalAtTime: ` o {time}`,

    // Kanały / wysyłka
    deliveryChannels: `Kanały wysyłki`,
    channelEmail: `E-mail`,
    sendAlsoOta: `Wysyłaj także przez OTA`,
    sendTime: `Godzina wysyłki`,

    // Edytor
    editorSubtitle: `Skonfiguruj według języka. Wskazówka: używaj emoji i krótkiego tekstu.`,
    translateTitle: `Przetłumacz z {lang} na pozostałe języki`,
    translatingLangLabel: `Tłumaczenie: {lang}…`,
    translatingGeneric: `Tłumaczenie…`,
    translate: `Przetłumacz`,

    // Załączniki
    uploading: `Przesyłanie…`,
    attach: `Załącz`,
    emojis: `Emoji`,
    variables: `Zmienne`,
    variablesHint: `Kliknij, aby je wstawić. Przy wysyłce zostaną zastąpione prawdziwymi danymi rezerwacji.`,
    uploadDone: `Wysłano. Zapisywanie na serwerze…`,
    uploadSizeProgress: `{done} z {total} MB`,
    attachHint: `Zdjęcia i PDF do {fileMb} MB · filmy MP4 do {videoMb} MB.`,
    whatsappLimits: `Takie są limity dopuszczane przez WhatsApp.`,
    openFile: `Otwórz {name}`,
    attachmentFallback: `załącznik`,
    delete: `Usuń`,
    open: `Otwórz`,
    arrivalAttachments: `Załączniki instrukcji przyjazdu`,
    welcomeAttachments: `Załączniki wiadomości powitalnej`,
    attachHintFull: `Zdjęcia i PDF do {fileMb} MB · filmy MP4 do {videoMb} MB. Takie są limity dopuszczane przez WhatsApp.`,
    noAttachments: `Nie ma jeszcze załączników.`,
    editorSubtitleProperty: `Skonfiguruj według języka i dołącz pliki (zdjęcia, PDF, wideo).`,

    // Zapis
    saveData: `Zapisz dane`,
    saving: `Zapisywanie…`,

    // Podsumowanie zamków
    locksConfigured: `Skonfigurowane zamki`,
    accessMethodConfigured: `Skonfigurowana metoda dostępu`,
    guestAccess: `Dostęp gościa`,
    accessDisabledHtml: `Wysyłanie kodów dostępu jest <strong>wyłączone</strong>, nie zostaną dołączone do instrukcji przyjazdu.`,
    noAccessMethod: `Dla tego zakwaterowania nie skonfigurowano jeszcze metody dostępu.`,
    locksHint: `Konfiguruje się to w karcie "Zamki i dostęp" w ofercie.`,

    // Podgląd
    online: `online`,
    previewDayArrival: `Dzień przyjazdu`,
    previewAfterRegister: `Po check-inie`,
    previewPlaceholder: `Napisz wiadomość, aby zobaczyć tutaj podgląd…`,
    previewIncludesAccess: `Zawiera skonfigurowany dostęp`,
    languageLabel: `Język: {lang}`,
    previewFallbackName: `Twoje zakwaterowanie`,
    previewFallbackAccommodation: `Twoje zakwaterowanie`,

    // Podsumowania zamków (wyliczane)
    lockNoteDynamic: `Dla każdej rezerwacji automatycznie generowany jest nowy klucz`,
    lockTagBox: `Kod skrytki na klucze`,
    lockTag: `Kod`,
    lockCodePending: `Kod oczekuje na konfigurację`,
    lockCodeValue: `{tag}: {code}`,
    lockLabelDefault: `Wejście`,

    // Podgląd wiadomości o dostępie (wyliczane)
    lockMsgDynamic: `🔒🔑 *{label} · {name}*\n\nTwój kod dostępu to: *58117*\n\nWażny przez cały pobyt.`,
    lockMsgBox: `🔑 *{label} · {name}*\n\nSkrytka na klucze otwiera się kodem: *{code}*\n\nW środku znajdziesz klucze do zakwaterowania. Prosimy odłożyć je z powrotem przy wyjeździe.`,
    lockMsgStatic: `🔒🔑 *{label} · {name}*\n\nKod do zamka to: *{code}*\n\nUżyj go, aby otworzyć drzwi zakwaterowania.`,

    // Etykiety zmiennych (wyliczane)
    varGuestName: `Imię gościa`,
    varFullName: `Imię i nazwisko`,
    varCheckinDate: `Data check-inu`,
    varCheckoutDate: `Data check-outu`,
    varCheckinTime: `Godzina check-inu`,
    varCheckoutTime: `Godzina check-outu`,
    varNights: `Liczba nocy`,
    varGuests: `Liczba gości`,

    // Opcje zamków (wyliczane)
    lockOptBoxTitle: `Skrytka na klucze`,
    lockOptBoxDesc: `Klucze znajdują się w bezpiecznej skrytce.`,
    lockOptDynamicTitle: `Zamek inteligentny`,
    lockOptDynamicDesc: `Każda rezerwacja automatycznie tworzy nowy klucz.`,
    lockOptStaticTitle: `Zamek ze stałym kodem`,
    lockOptStaticDesc: `Skrytka na klucze lub zamek ze stałym kodem.`,

    // Domyślna wiadomość o przyjeździe (wyliczana)
    defaultArrivalMessage: `🏡 *Instrukcje przyjazdu*\n\nCześć *{guest}* 👋\n\nPo przyjeździe skieruj się do głównego wejścia do zakwaterowania. 🔑\n\nJeśli potrzebujesz pomocy, napisz do nas na tym samym WhatsApp 📲\n\nUdanego pobytu! ✨`,

    // Kontekst obiektu (odziedziczony)
    inheritedChannelsTitle: `Kanały odziedziczone z oferty`,
    inheritedListingPrefix: `Ten obiekt korzysta ze scentralizowanego powitania oferty`,
    emailChannel: `E-mail`,
    otaActive: `OTA aktywne`,
    inheritedNote: `Aby zmienić wysyłkę tego powitania przez OTA, zrób to w ustawieniach oferty.`,
    propertyDeliveryTitle: `Jak zostanie wysłane to powitanie?`,
    propertyDeliverySubtitle: `Skonfiguruj kanały wysyłki dla tego obiektu.`,
    propertyDeliveryNote: `Te kanały pozostają domyślnie aktywne. Tutaj możesz też dodać wysyłkę przez OTA dla tego obiektu.`,
    otaRowTitle: `Wysyłaj wiadomości powitalne przez OTA`,
    otaRowText: `Spróbujemy wysłać powitanie tego obiektu przez Booking.com i Airbnb za pomocą Channex, wraz ze skonfigurowanymi załącznikami.`,
    otaRowHint: `Zapisuje się razem z wiadomością powitalną i załącznikami.`,

    // Powiadomienia / walidacja
    toastLoadError: `Nie udało się wczytać wiadomości.`,
    toastOtaUpdated: `Kanał OTA został zaktualizowany`,
    toastOtaError: `Nie udało się zaktualizować wysyłki przez OTA`,
    toastSendTimeUpdated: `Godzina wysyłki została zaktualizowana`,
    toastSendTimeError: `Nie udało się zapisać godziny`,
    toastArrivalEnabled: `Instrukcje przyjazdu włączone`,
    toastArrivalDisabled: `Instrukcje przyjazdu wyłączone`,
    toastStatusError: `Nie udało się zaktualizować statusu`,
    toastWelcomeEnabled: `Wiadomość powitalna włączona`,
    toastWelcomeDisabled: `Wiadomość powitalna wyłączona`,
    toastModeUpdated: `Tryb został zaktualizowany`,
    toastModeError: `Nie udało się zaktualizować trybu`,
    toastAttachUploaded: `Załączniki zostały przesłane`,
    toastAttachUploadError: `Błąd podczas przesyłania załączników`,
    toastAttachDeleted: `Załącznik został usunięty`,
    toastAttachDeleteError: `Nie udało się usunąć załącznika`,
    toastChangesSaved: `Zmiany zapisane`,
    toastTranslateEmpty: `Napisz wiadomość w aktywnym języku przed tłumaczeniem.`,
    toastTranslateSuccess: `Przetłumaczono języki: {count}! Sprawdź każdą zakładkę przed zapisaniem.`,
    toastTranslatePartial: `Przetłumaczono: {success}, nieudane: {failed}. Możesz spróbować ponownie.`,
    toastTranslateNone: `Nie udało się przetłumaczyć żadnego języka. Spróbuj ponownie.`,

    // Błędy walidacji plików (WhatsApp)
    fileErrorVideoFormat: `❌ Plik {name} to film {ext}, a WhatsApp obsługuje tylko MP4. Przekonwertuj go na MP4 i prześlij ponownie.`,
    fileErrorTooBig: `❌ Plik {name} ma {mb} MB, a maksimum to {limMb} MB. `,
    fileErrorTooBigVideo: `WhatsApp nie dopuszcza większych filmów: skompresuj go lub skróć.`,
    fileErrorTooBigFile: `WhatsApp nie dopuszcza większych plików.`,
  },
};
